export const PERMISSION_LABELS = {
    'dashboard.view': 'Dashboard Access',
    'conversations.view': 'Live Chat & Conversations',

    'instructions.view': 'View Bot Configuration',
    'instructions.manage': 'Manage Bot Configuration',

    'staff.view': 'View Team Members',
    'staff.manage': 'Manage Team Members',

    'items.view': 'View Product Catalog',
    'items.manage': 'Manage Product Catalog',

    'users.view': 'View User Accounts',
    'users.manage': 'Manage User Accounts & Permissions',

    'whatsapp_numbers.view': 'View WhatsApp Channels',
    'whatsapp_numbers.manage': 'Manage WhatsApp Channels',

    'whatsapp_templates.view': 'View Message Templates',
    'whatsapp_templates.manage': 'Manage Message Templates',

    'customer_summaries.view': 'View Client Summaries',
    'customer_summaries.manage': 'Manage Client Summaries',

    'summary_instructions.view': 'View Summary Prompts',
    'summary_instructions.manage': 'Manage Summary Prompts',

    'companies.view': 'View Client Accounts',
    'companies.manage': 'Manage Client Accounts & Limits'
};

export const MODULE_LABELS = {
    'dashboard': 'Dashboard',
    'conversations': 'Conversations',
    'instructions': 'Bot Configuration',
    'staff': 'Team Members',
    'items': 'Product Catalog',
    'users': 'User Accounts',
    'whatsapp_numbers': 'WhatsApp Channels',
    'whatsapp_templates': 'Message Templates',
    'customer_summaries': 'Client Summaries',
    'summary_instructions': 'Summary Prompts',
    'companies': 'Client Accounts',
};

export const SUPER_ADMIN_ONLY_PREFIXES = ['companies.'];

export const canAccessPermission = (user, permission) => {
    if (!user || !permission) return false;
    if (user.role === 'super_admin') return true;

    if (user.role === 'company_admin' && !SUPER_ADMIN_ONLY_PREFIXES.some((prefix) => permission.startsWith(prefix))) {
        return true;
    }

    const permissions = Array.isArray(user.permissions) ? user.permissions : [];
    return permissions.includes(permission);
};
